import { get ,post} from '@/utils/request'
import axios from "axios";
const TARGET_SERVER = process.env.VUE_ENV === "server";
const baseUrl = process.env.config.RRDH_HOST;


export default {
    getRankUser: query => get('/rrbi/index/getRankUser', query),
    getRecommendList: query => get('/rrbi/index/getRecommendList', query),
    getHostList: query => get('/rrbi/index/getHostList', query),
    getBannerData: query => get('/rrbi/index/getBannerData', query),
    getIndexData: query => get('/rrbi/index/getIndexData', query),
    saveReport: data => post('/rrbi/report/save', data),
    saveCollect: data => post('/rrbi/collect/save', data),
    dolike: data => get('/rrbi/like/dolike', data),
    dislike: data => get('/rrbi/like/dislike', data),
    addFollow: id => get('/rrbi/follow/'+id),
    addUserInterest: data => get('/rrbi/interests/addUserInterest',data),
    doshare: data => get('/rrbi/share/doshare',data),
    addBlackList: id => get('/rrbi/friends/black/'+id+"?time="+new Date().getMilliseconds()),
    doshare2: data => get('/rrbi/share/doshare2',data),
}


export function fetchRankUserList({ id, cookies ,params}) {
    return axios.post(baseUrl + `/rrbi/index/getRankUser`, params,{
        headers: getCommonHeader({ cookies })
    });
}
function getCommonHeader({ cookies }) {
    if (TARGET_SERVER && cookies) {
        return { cookie: getCookieString(cookies) };
    } else {
        return null;
    }
}
function getCookieString(cookies) {
    let cookieStr = "";
    for (var variable in cookies) {
        //if (Object.prototype.hasOwnProperty.call(cookies, "variable")) {
        cookieStr += `${variable}=${encodeURIComponent(cookies[variable])}; `;
        //}
    }
    return cookieStr;
}